import { Dialog } from 'element-ui'
import './style.scss'

const YDialog = Dialog
YDialog.$depends = [Dialog]
YDialog.$name = 'y-dialog'
YDialog._name = 'Dialog 对话框'

export default YDialog
